import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import SkeletonLoader from "../Home/Slider/SkeletonLoader";
import CourseService from "../../../services/CourseService";
import { getLastBlock } from "../../../utils/helpers";
import LearningItemDetailsPage from "./LearningItemDetailsPage";
import "./LearningItemDetailsPage.css";

function LearningItemDetailsRoute({ expectedType, slugParam }) {
  const params = useParams();
  const slug = params[slugParam];
  const [learningItem, setLearningItem] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    let isMounted = true;

    const loadLearningItem = async () => {
      setIsLoading(true);
      setErrorMessage("");
      setLearningItem(null);

      const learningItemId = slug ? getLastBlock(slug) : null;
      if (!learningItemId) {
        if (isMounted) {
          setErrorMessage("The requested course or session is unavailable.");
          setIsLoading(false);
        }
        return;
      }

      try {
        const response = await CourseService.getDetails(learningItemId);

        if (!isMounted) return;

        if (
          response.status === "success" &&
          response.data &&
          response.data.type === expectedType
        ) {
          setLearningItem(response.data);
        } else {
          setErrorMessage("The requested course or session is unavailable.");
        }
      } catch {
        if (isMounted) {
          setErrorMessage(
            "Unable to load this course or session. Please try again later."
          );
        }
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    loadLearningItem();

    return () => {
      isMounted = false;
    };
  }, [expectedType, slug]);

  if (isLoading) return <SkeletonLoader />;

  if (errorMessage || !learningItem) {
    return (
      <main className="ns-course-page ns-route-state">
        <div className="ns-route-state__content">
          <span className="ns-route-state__icon" aria-hidden="true">
            <i className="fa-solid fa-circle-exclamation"></i>
          </span>
          <h1>Learning item unavailable</h1>
          <p>{errorMessage}</p>
          <Link className="ns-primary-btn" to="/availables-courses">
            Browse courses and sessions
            <i className="fa-solid fa-arrow-right"></i>
          </Link>
        </div>
      </main>
    );
  }

  return <LearningItemDetailsPage data={learningItem} />;
}

export default LearningItemDetailsRoute;
